import React from "react";
import VeloxChemical from "../assets/veloxchemical.jpeg";

const specs = [
    { label: "Acid Storage", value: "2,800 Ton Capacity" },
    { label: "Ilmenite Milling", value: "325 Mesh Precision" },
    { label: "Water Works", value: "RO & Effluent Treatment" },
    { label: "Environment", value: "MoEF Clearance Approved" },
];

export default function FacilitySection() {
    return (
        <section className="border-b border-border bg-surface px-6 py-20" id="facility">
            <div className="mx-auto flex max-w-screen-xl flex-col gap-12 md:flex-row">
                <div className="w-full md:w-1/2">
                    <figure className="outline-1 -outline-offset-1 outline-foreground/5">
                        <img
                            alt="Aerial view of the VELOX titanium dioxide plant in Thoothukudi"
                            className="aspect-[3/2] w-full object-cover"
                            height="800"
                            width="1200"
                            loading="lazy"
                            src={VeloxChemical}
                        />
                        <figcaption className="mt-3 font-mono text-[11px] uppercase tracking-widest text-muted-foreground">
                            Fig. 01 / Facility
                        </figcaption>
                    </figure>
                </div>
                <div className="flex w-full flex-col justify-center md:w-1/2">
                    <span className="mb-4 font-mono text-[11px] uppercase tracking-widest text-accent">
                        01 / Location &amp; Scale
                    </span>
                    <h2 className="mb-6 text-3xl font-bold tracking-tight">
                        The Thoothukudi Complex
                    </h2>
                    <p className="mb-8 max-w-xl text-lg text-muted-foreground">
                        Operating under Velox Chemicals Pvt. Ltd., our plant is
                        engineered for high-purity production with zero-waste bypass systems.
                    </p>
                    <div className="grid grid-cols-2 gap-x-8 gap-y-8 border-t border-border pt-8">
                        {specs.map((spec) => (
                            <div key={spec.label}>
                                <span className="mb-1 block font-mono text-[11px] uppercase tracking-widest text-muted-foreground">
                                    {spec.label}
                                </span>
                                <p className="font-medium">{spec.value}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}